// @flow

import React from 'react';
import classNames from 'classnames';

import Svg from 'shared/_ui/svg/Svg';

import style from './UiStub.module.css';

type PropsType = {
  title: any,
  iconMod: any,
  styleMod: any,
  icon: any
};

function UiStub({ title, styleMod, iconMod, icon = 'stub' }: PropsType) {
  return (
    <div className={classNames(style.stub, style[`mod-${styleMod}`])}>
      <Svg icon={icon} styleClassName={classNames(style.stubIcon, style[`mod-${iconMod}`])} />
      <p className={style.stubTitle}>{title}</p>
    </div>
  );
}

export default UiStub;
